import Landing from '../../pages/landing'

export default {
  path: 'landing',
  component: Landing,
}



// WEBPACK FOOTER //
// ./src/routes/Landing/index.js